<template>
    <span v-if="mostrarBtn" class="ml-2">
        <b-button variant="primary" @click.stop="abrir()">
            <span> <i class="fa fa-plus"></i> Nova Entrega Manual</span>
        </b-button>
        <b-modal v-model="mostrarModal" @show="show()">
            <div slot="modal-title">Entrega Manual</div>
            <b-alert show v-if="limites">
                <span>Carga Horária Disponível</span><br />
                <span v-if="limites.consultoriaCargaHorariaMax > 0"
                    >CONSULTORIA:
                    <strong>{{ limites.consultoriaCargaHorariaMax }}</strong
                    ><br
                /></span>
                <span v-if="limites.instrutoriaCargaHorariaMax > 0"
                    >INSTRUTORIA:
                    <strong>{{
                        limites.instrutoriaCargaHorariaMax
                    }}</strong></span
                >
            </b-alert>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Natureza</label>
                        <b-form-select
                            :plain="true"
                            :options="naturezas"
                            v-model="natureza"
                            text-field="descricao"
                            value-field="codigo"
                            :disabled="!podeEscolherNatureza"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descritivo</label>
                        <b-form-textarea
                            v-model="descritivo"
                            :rows="2"
                            @input="$v.descritivo.$touch()"
                            :state="$v.descritivo.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >O descritivo da entrega é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.dataPrevisao.$error ? false : null"
                        invalid-feedback="Data de previsão é obrigatória"
                    >
                        <label>Previsão de Entraga</label>
                        <date-picker
                            v-model="dataPrevisao"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                            @input.native="$v.dataPrevisao.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Carga Horária</label>
                        <b-form-input
                            type="text"
                            v-model="cargaHoraria"
                            @input="$v.cargaHoraria.$touch()"
                            :state="$v.cargaHoraria.$error ? false : null"
                            v-mask="'########'"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            ><span
                                v-if="
                                    $v.cargaHoraria.$error &&
                                        !$v.cargaHoraria.required
                                "
                                >A carga horária é obrigatória</span
                            >
                            <span
                                v-if="
                                    $v.cargaHoraria.$error &&
                                        !$v.cargaHoraria.limiteOk
                                "
                                >O valor informado está acima da carga horária
                                disponível</span
                            ></b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmar()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import { naturezas } from '../Naturezas'

const limiteOk = (value, vm) => {
    if (vm.limites) {
        if (
            (vm.natureza === 0 &&
                value <= vm.limites.consultoriaCargaHorariaMax) ||
            (vm.natureza === 1 &&
                value <= vm.limites.instrutoriaCargaHorariaMax)
        ) {
            return true
        }
    }
    return false
}

export default {
    props: {
        contratacao: {
            type: Object,
            required: true,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            descritivo: '',
            natureza: -1,
            dataPrevisao: null,
            cargaHoraria: 0,
            justificativa: '',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            naturezas: [
                { codigo: 0, descricao: 'CONSULTORIA' },
                { codigo: 1, descricao: 'INSTRUTORIA' }
            ],
            limites: null
        }
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        show() {
            this.natureza =
                this.contratacao.idNatureza !== 2
                    ? this.contratacao.idNatureza
                    : -1
            this.obterLimitesEntregaManual()
        },

        fechar() {
            this.reset()
            this.mostrarModal = false
        },

        reset() {
            this.descritivo = ''
            this.natureza = -1
            this.dataPrevisao = null
            this.cargaHoraria = 0
            this.justificativa = ''
            this.erros = []
            this.limites = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        obterLimitesEntregaManual() {
            this.$store.dispatch('addRequest')
            this.contratacoesServicos
                .obterLimitesEntregaManual(this.contratacao.codContratacao)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.limites = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmar() {
            this.$swal({
                title: 'Entrega Manual',
                html: `Confirma a criação da entrega manual?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.inserirEntregaManual()
                }
            })
        },

        inserirEntregaManual() {
            this.$store.dispatch('addRequest')
            let entregaManualDto = {
                codContratacao: this.contratacao.codContratacao,
                tipo: this.natureza,
                descritivo: this.descritivo,
                dataPrevisao: this.$moment(
                    this.dataPrevisao,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                cargaHoraria: this.cargaHoraria,
                justificativa: this.justificativa
            }
            this.contratacoesServicos
                .inserirEntregaManual(entregaManualDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro inserido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                            this.fechar()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.$temAcesso('CRED-UABS-CONT-04') &&
                this.contratacao.permiteEntregaManual
            )
        },

        podeEscolherNatureza() {
            if (this.limites) {
                if (
                    this.limites.consultoriaCargaHorariaMax > 0 &&
                    this.limites.instrutoriaCargaHorariaMax > 0
                ) {
                    return true
                } else if (
                    this.limites.consultoriaCargaHorariaMax > 0 &&
                    this.limites.instrutoriaCargaHorariaMax == 0
                ) {
                    this.natureza = 0
                    return false
                } else if (
                    this.limites.consultoriaCargaHorariaMax == 0 &&
                    this.limites.instrutoriaCargaHorariaMax > 0
                ) {
                    this.natureza = 1
                    return false
                }
            }
            return true
        }
    },

    validations: {
        descritivo: {
            required
        },
        natureza: {
            required,
            minValue: minValue(0)
        },
        justificativa: {
            required
        },
        dataPrevisao: {
            required
        },
        cargaHoraria: {
            required,
            minValue: minValue(1),
            limiteOk
        }
    }
}
</script>
